import { ROLES } from "@pharmupp/p3-front-commons"

const presidentApiRoleConf = {
  resourceUrl: "/api/operation/bonus/upp",
  referentialUrl: "/api/operation/bonus/upp/referential/list",
}

export const apiRoleConf = {
  [ROLES.ADMIN]: {
    resourceUrl: "/api/operation/bonus",
    referentialUrl: "/api/operation/bonus/referential/list",
  },
  [ROLES.UPP_PRESIDENT]: presidentApiRoleConf,
  [ROLES.UPP_REPRESENTATIVE]: presidentApiRoleConf,
}
